module.exports = __webpack_public_path__ + "img/quest_validation_warning.676ac4e7.svg";